
//Import React Hooks
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom' //useParams to get the id transmitted in the url


// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Week from '../../components/week/Week.jsx'
import EleveList from '../../components/elevelist/EleveList.jsx'
import CalendarCart from '../../components/calendarcart/CalendarCart.jsx'
import Background from '../../components/background/Background.jsx'
import Comments from '../../components/comments/Comments.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { elevesSlice } from "../../store/elevesSlice.js";
import { formulesSlice } from "../../store/formulesSlice.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

// config
import { listFidelite, listNiveau } from '../../config/niveau-fidelite-config.js';

//Utils 
import { creneauxSorter2, creneauxSorter3 } from '../../utils/creneaux_sorter.js';
import setNumResa from '../../utils/set_num_resa.js';
import convertHoraire from '../../utils/convert_horaire.js';


//// - we get infos from the DB to show editables infos for a Resa ////
function ResaMatched() { // full page as component imported in router

    const { idResa } = useParams(); //id of the selected resa, in url (as string)
    const navigate = useNavigate();

    const [allInfos, setAllInfos] = useState([]);
    const [matchWally, setMatchWally] = useState();
    const [displayInfos, setDisplayInfos] = useState();
    let [fail, setFail] = useState(false);

    //// -- At first render :
    useEffect(() => {
        async function patchResa() { //we add this inner function to manage asynchrone
            let resaInfos = await getResa(); // get resa infos from DB ...

            setAllInfos(resaInfos);

        } //end of async function
        patchResa(); //call the inner asnchrone function
    }, [idResa])
    //// --

    //// -- At allInfos init :
    useEffect(() => {
        allInfos.Client && handleResa(allInfos)
    }, [allInfos])
    //// --



    async function getResa() { // Get Resa Infos from DB (request with joins...)

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/resa/${idResa}`,

            });
            //console.log(response);
            const infos = response.data;
            return infos;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    function handleResa(allInfos) {
        console.log(allInfos.match);
        if (allInfos.match === false) {
            navigate("../error")
        }

        console.log(allInfos);
        let sortedInfos = sortElevesCreneaux(allInfos.CreneauEleves);
        setDisplayInfos(sortedInfos);

        updateElevesNbCours(sortedInfos.eleves, sortedInfos.creneaux);

    }

    function sortElevesCreneaux(creneaux) {

        let allEleves = [];
        let allCreneaux = [];
        let dateList = [];

        creneaux.map((creneauEleve) => { // for every line in CreneauEleve Table...
            //// -- We want a list of eleves

            // if eleve not in the list already...
            if (allEleves.filter((eleve) => eleve.id === creneauEleve.Eleve.id_eleve).length === 0) {
                allEleves.push({  //... we add this eleve to the list, with his infos reformated for global state "Eleves" 
                    id: creneauEleve.Eleve.id_eleve,
                    prenom: creneauEleve.Eleve.prenom,
                    age: creneauEleve.Eleve.age,
                    nb_cours: creneauEleve.Eleve.nb_cours,
                });
                allEleves.sort((e1, e2) => e1.id > e2.id ? 1 : -1); // We sort the list of eleves, as they "arrive" in disorder
            }

            if (allCreneaux.filter((creneau) => creneau.id === creneauEleve.Creneau.id_creneau).length === 0) {
                allCreneaux.push({
                    eleves: [{ id: creneauEleve.Eleve.id_eleve, prenom: creneauEleve.Eleve.prenom }],
                    date: creneauEleve.Creneau.date,
                    horaire: creneauEleve.Creneau.horaire,
                    id: creneauEleve.Creneau.id_creneau
                });
                allCreneaux.sort((d1, d2) => creneauxSorter2(d1, d2));
            }
            else {
                allCreneaux.find((c) => c.id === creneauEleve.Creneau.id_creneau).eleves.push({ id: creneauEleve.Eleve.id_eleve, prenom: creneauEleve.Eleve.prenom });
            }


            dateList.push(creneauEleve.Creneau.date);


        });// end of map

        let dateSet = new Set(dateList);
        let newDatesList = Array.from(dateSet); //we need this list of date to display a calendar with only days with creneaux
        newDatesList.sort((d1, d2) => creneauxSorter3(d1, d2));

        return ({ eleves: allEleves, creneaux: allCreneaux, dateList: newDatesList })
    }//end of function


    function updateElevesNbCours(eleves, creneaux) {
        let nbSuccess = 0;
        let problemes = [];

        eleves.map((eleve) => {
            let oldNbCours = eleve.nb_cours;
            let newNbCours = creneaux.filter((creneau) => creneau.eleves.find((e) => eleve.id === e.id) ? true : false/* eleve.id === creneau.eleve_id */).length
            console.log(eleve.id, parseInt(oldNbCours + newNbCours))

            axios.put(`${baseURL}/eleve/${eleve.id}`, { //...we add him in the db
                nb_cours: parseInt(oldNbCours + newNbCours)
            })
                .then((response) => {
                    if (response.status === 200) { //modif ok : code 200...
                        nbSuccess++;
                    }
                    else {
                        problemes.push(response.status);
                    }
                })
                .catch(error => {
                    problemes.push(error);
                })
        })//end of map

        if (nbSuccess === eleves.length) { //every request went good
            console.log("modifs nbcours ok");
        }
        else {
            console.log(problemes.length + " erreurs modifs nbcours");
        }
    } // end of function


    return (
        <div className="bg-relative">
            <Background ind={2} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">

                    <WallyBanner />

                    <div className="match">
                        <div className="match-intro">
                            <h1>Réservation confirmée</h1>
                            <p>{`La réservation ${allInfos.Client && setNumResa({ total: allInfos.total, created: allInfos.created, id_resa: allInfos.id_resa })} pour ${allInfos.Client && allInfos.Client.prenom} ${allInfos.Client && allInfos.Client.nom} a déjà été validée.`}</p>
                        </div>

                        <div className="match-jours">
                            {displayInfos && displayInfos.dateList.map((date) => (
                                <div className="match-jours-bloc" key={date}>
                                    <h3 className="match-jours-bloc-date">{dayjs(date).format("DD/MM/YYYY")}</h3>
                                    {displayInfos.creneaux.filter((c) => c.date === date).map((creneau) => (
                                        <div className="match-jours-bloc-creneau" key={creneau.id}>
                                            <p className="match-jours-bloc-creneau-horaire">{convertHoraire(creneau.horaire, "horaire")}</p>
                                            <ul className="match-jours-bloc-creneau-eleves">
                                                {creneau.eleves.map((e, index) => (
                                                    <li key={index}>{e.prenom}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>


                    </div>


                </div>
            </main>
        </div>
    );
}

export default ResaMatched;
